export const normalizePhoneNumber = (value: string | undefined) => {
  if (!value) return ''

  return value
    .replace(/[\D]/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})(\d+?)/, '$1')
}

export const normalizeCepNumber = (value: string | undefined) => {
  if (!value) return ''
  const num = value.replace(/\D/g, '')
  if (num.length <= 5) {
    return num.replace(/^(\d{5})/, '$1')
  }
  return num.replace(/(\d{5})(\d)/, '$1-$2').substring(0, 9)
}

export const normalizeCreditCardNumber = (value: string | undefined) => {
  if (!value) return ''

  const num = value.replace(/\D/g, '')

  if (num.length === 14) {
    return num.replace(/(\d{4})(\d{6})(\d{4})/g, '$1 $2 $3')
  }
  if (num.length === 15) {
    return num.replace(/(\d{4})(\d{6})(\d{5})/g, '$1 $2 $3')
  }
  if (value.replace(/\D/g, '').length >= 16) {
    return num.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/g, '$1 $2 $3 $4').substring(0, 20)
  }

  return value
}

export const normalizeCreditCardExp = (value: string | undefined) => {
  if (!value) return ''

  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .substring(0, 5)
}

// export const maskCrditCardNumber = [
//   {
//     mask: '0000 000000 0000',
//     maxLength: 14,
//   },
//   {
//     mask: '0000 000000 00000',
//     maxLength: 15,
//   },
//   {
//     mask: '0000 0000 0000 0000',
//   },
// ]
